import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { formatRelativeDateTime } from '../utils/relative-date-time';

/**
 * Relative datetime display for timestamps (e.g. last login).
 * Uses shared `formatRelativeDateTime` so the same rules can be reused outside templates.
 */
@Pipe({
  name: 'relativeDateTime',
  standalone: false,
})
export class RelativeDateTimePipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(value: Date | string | number | null | undefined): string {
    const lang = this.translate.currentLang || 'en';
    const locale = lang === 'ar' ? 'ar' : 'en-US';

    return formatRelativeDateTime(value, {
      locale,
      am: this.translate.instant('date.am'),
      pm: this.translate.instant('date.pm'),
      justNow: this.translate.instant('date.now'),
      minutesAgo: (minutes) =>
        this.translate.instant('date.relative.minutesAgo').replace('$value', String(minutes)),
      hoursAgo: (hours) => {
        const key =
          hours === 1 ? 'date.relative.hoursAgo.one' : 'date.relative.hoursAgo.other';
        return this.translate.instant(key).replace('$value', String(hours));
      },
      yesterday: (time) =>
        this.translate.instant('date.relative.yesterday').replace('$time', time),
      absolute: (date, time) =>
        this.translate
          .instant('date.relative.absolute')
          .replace('$date', date)
          .replace('$time', time),
    });
  }
}
